var heading_default = {
  "fontElementMap": "wdNpI",
  "elementSpacing": "K1qln",
  "headerOne": "qvbbV K1qln",
  "headerTwo": "pUbhk K1qln",
  "headerThree": "QK3Sh K1qln",
  "headerFour": "Gjy83 K1qln",
  "headerFive": "p-o-k K1qln",
  "headerSix": "_5n5Ku K1qln",
  "child": "hNTrR"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
